import { SUPPORTTYPE } from '../constants/bakery/nft'

export function userNftSupportToken(nftType: any) {
  let tokenName: string
  switch (nftType) {
    case 101:
      tokenName = SUPPORTTYPE.SFP
      break;
    case 107:
    case 113:
    case 117:
    case 118:
    case 119:
      tokenName = SUPPORTTYPE.BUSD
      break;
    case 104:
    case 114:
      tokenName = SUPPORTTYPE.DOGGY
      break;
    case 108:
      tokenName = SUPPORTTYPE.BARK
      break;
    default:
      tokenName = SUPPORTTYPE.BAKE
      break;
  }
  return tokenName
}


